// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2W3pc","signatureBlock":"Footer_signatureBlock__1Lqd7","signature":"Footer_signature__1iu3S"};